/**
 * Two-state buttons ([data-toggle-pressed]) — the video feed's mute and
 * captions controls. Flips aria-pressed; the player integration will read it.
 */
export function initToggles(scope = document) {
  scope.addEventListener('click', (e) => {
    const button = e.target.closest('[data-toggle-pressed]');
    if (!button) return;
    button.setAttribute('aria-pressed', String(button.getAttribute('aria-pressed') !== 'true'));
  });
}
